import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
import FullParagraphAdvancedFieldsConfig from "segments/desktop/core-components/full-paragraph/advanced-fields-config";
import { LG, LGR, MD, SM, XL, XS, XXL } from "constants/sizes";

const { buttonTopMargin, topicBottomMargin, ...restOfParagraphConfig } = FullParagraphAdvancedFieldsConfig;

export default {
  type: FIELD_TYPES.NESTED,
  label: "",
  fields: {
    ...SharedAdvancedFieldsConfig,
    fullParagraphAdvancedConfig: {
      type: FIELD_TYPES.NESTED,
      label: "Paragraph Advanced Config",
      fields: {
        ...restOfParagraphConfig,
        selectedTitleSize: {
          type: FIELD_TYPES.COMBO,
          label: "Selected title Size",
          options: [
            { value: XS, text: "22px (formerly 24px)" },
            { value: SM, text: "28px (formerly 32px)" },
            { value: MD, text: "36px (formerly 40px)" },
            { value: LG, text: "44px (formerly 50px)" },
            { value: LGR, text: "54px (formerly 60px)" },
            { value: XL, text: "64px (formerly 72px)" },
            { value: XXL, text: "72px (formerly 80px)" }
          ]
        }
      }
    }
  }
};
